import { SpareProductSize } from '@savgroup-front-common/types';

const getSparePartSizeMessages = (value: SpareProductSize): string => {
  if (value === SpareProductSize.NONE) {
    return '-';
  }

  return value;
};

export default getSparePartSizeMessages;
